// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"EntrypointRow_cardContainer__8w6kj","textContainer":"EntrypointRow_textContainer__jGP91"};